import React from 'react';

// Utils
import { scrollToPageElement } from 'utils/componentsCommon';
import { mediaQueries, fromTabletMediaQuery, fromTablethoriMediaQuery } from 'utils/MediaQueriesDeprecated';

// Components
import
{
    Hero,
    PenlySeo,
    PenlyPlayPension,
    Spacer,
    Button,
}
    from 'components';

export default function PenlyPlay() {
    const title = 'Penly Play - Leg dig til din drømmepension';
    const description = 'Bliv guidet til en klogere pension, og se hvor stor en forskel små ændringer nu vil have på din pension.';
    const image = { url: '/static/gfx/content/penly-content-26.jpg' };
    const fromTablet = mediaQueries(fromTabletMediaQuery);
    const fromTablethori = mediaQueries(fromTablethoriMediaQuery);

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } />

            <Hero full={ true } overlay={ true } figure={ image.url } rowlayout={ true }>
                <section className="title">
                    <div>
                        <h1 className="penlyPlayPageTitle">VIL DU SELV BESTEMME HVORNÅR DU SKAL PÅ PENSION?</h1>
                        { fromTablethori && <br/> }
                        <p>Se, hvordan dine valg i dag påvirker din pension. Indtast nogle få oplysninger, og find ud af, hvad der skal til for at få den fremtid, du drømmer om.</p>
                        <Spacer />
                        <Button size={ fromTablet ? 'large' : 'medium' } onClick={ () => scrollToPageElement('#playstart') }>Start Penly Play</Button>
                    </div>
                </section>
                <section>
                    <img src="/static/gfx/PenlyPlayLogoWhiteSecondary.svg"></img>
                </section>
            </Hero>

            { fromTablethori && <Spacer size="large" /> }

            <PenlyPlayPension id="playstart" />
        </>
    );
}
